import { createFileRoute } from "@tanstack/react-router";
import { MailTestPage } from "../../../../features/admin/mail-test/mail-test-page";

export const Route = createFileRoute("/_auth/_frame/admin/mail-test")({
  component: MailTestPage,
});
